import { Component } from 'preact';
import PropTypes from 'prop-types';
import ItemPlaceholder from './ItemPlaceholder';
import ButtonLoadMore from './ButtonLoadMore';
import Item from './Item';

class List extends Component {
  componentDidMount() {
    window.matchHeight.match('.list-direct-sales-vehicles');
  }

  componentDidUpdate() {
    window.matchHeight.match('.list-direct-sales-vehicles');
  }

  render() {
    const {
      items,
      part_link,
      loading,
      loadingMore,
      showLoadMore,
      onClickButtonLoadMore,
      ctaButtonText,
    } = this.props;

    return (
      <div className="list-direct-sales-vehicles__list">
        <div className="row">
          {loading &&
            !loadingMore &&
            Array.from({ length: 12 }).map(item => (
              <ItemPlaceholder key={item} />
            ))}

          {items.map(item => (
            <div className="col-md-6 col-lg-4 col-xl-3 list-direct-sales-vehicles__col-card">
              <Item
                slug={item.slug}
                image={item.item_image && item.item_image.middle_image}
                title={item.title}
                subtitle={item.subtitle}
                seal_list={item.seal_list}
                secondary_call={
                  item.item_offer && item.item_offer.secondary_call
                }
                main_call={item.item_offer && item.item_offer.main_call}
                featured={item.item_offer && item.item_offer.featured}
                description={item.item_offer && item.item_offer.description}
                extra={item.item_offer && item.item_offer.extra}
                badge={item.badge}
                part_link={part_link}
                brand={item.brand.name}
                ctaButtonText={ctaButtonText}
                expiredAt={item.expired_at}
                offerType={item.offer_type}
                categorySlug={item.category_slug}
              />
            </div>
          ))}
        </div>

        {showLoadMore && (
          <div>
            <ButtonLoadMore
              onClick={onClickButtonLoadMore}
              loading={loadingMore}
            />
          </div>
        )}
      </div>
    );
  }
}

List.defaultProps = {
  items: [],
  showLoadMore: false,
  loading: false,
  loadingMore: false,
  onClickButtonLoadMore() {},
};

List.propTypes = {
  items: PropTypes.arrayOf(Object),
  showLoadMore: PropTypes.bool,
  loading: PropTypes.bool,
  part_link: PropTypes.string,
  onClickButtonLoadMore: PropTypes.func,
  ctaButtonText: PropTypes.string,
  loadingMore: PropTypes.bool,
};

export default List;
